export const CurrencySymbols = {
    'USD': '$',
    'EUR': '€',
    'KRW': '₩',
    'CNY': '¥'
}
